// constants/travel-time.const.js

export const TRAVELTIME_TYPES = ["driving", "public_transport", "walking"];

export const TRAVELTIME_MINUTE_DEFAULTS = {
	driving: [15, 30, 45],
	public_transport: [15, 30, 45],
	walking: [5, 10, 15],
};
